/**
 * Image Limit Configuration for Arms Room
 * Enforces maximum 8 photos per inventory item
 */

// Maximum number of photos allowed per item
export const MAX_IMAGES_PER_ITEM = 8;

/**
 * Check if more images can be added
 * @param {number} currentCount - Current number of images
 * @returns {boolean} - True if more images can be added
 */
export const canAddMoreImages = (currentCount) => {
  return currentCount < MAX_IMAGES_PER_ITEM;
};

/**
 * Get remaining slots available for images
 * @param {number} currentCount - Current number of images
 * @returns {number} - Number of remaining slots
 */
export const getRemainingSlots = (currentCount) => {
  return Math.max(0, MAX_IMAGES_PER_ITEM - currentCount);
};

/**
 * Get image limit message for display
 * @param {number} currentCount - Current number of images
 * @returns {string} - Display message like "3/8 photos"
 */
export const getImageCountDisplay = (currentCount) => {
  return `${currentCount}/${MAX_IMAGES_PER_ITEM}`;
};

/**
 * Validate and limit files to available slots
 * @param {File[]} files - Array of files to add
 * @param {number} currentCount - Current number of images
 * @returns {{ acceptedFiles: File[], rejectedCount: number, message: string | null }}
 */
export const validateImageUpload = (files, currentCount) => {
  const remaining = getRemainingSlots(currentCount);
  
  if (remaining === 0) {
    return {
      acceptedFiles: [],
      rejectedCount: files.length,
      message: `Maximum ${MAX_IMAGES_PER_ITEM} photos per item. Remove existing photos to add new ones.`
    };
  }
  
  if (files.length <= remaining) {
    return {
      acceptedFiles: files,
      rejectedCount: 0,
      message: null
    };
  }
  
  // Partial acceptance
  const acceptedFiles = files.slice(0, remaining);
  const rejectedCount = files.length - remaining;
  
  return {
    acceptedFiles,
    rejectedCount,
    message: `Only ${remaining} photo${remaining === 1 ? '' : 's'} can be added. ${rejectedCount} photo${rejectedCount === 1 ? ' was' : 's were'} not added.`
  };
};
